import { CCol, CRow } from "@coreui/react";

import { Can } from "src/helpers/Auth";
import PropTypes from "prop-types";
import React from "react";
import ReactQueryLoading from "src/reusable/ReactQueryLoading";
import { useGetDataset } from "./services/DatasetServices";

const DatasetInfo = (props) => {
  const {
    isLoading: isDatasetLoading,
    status: datasetStatus,
    error: datasetError,
    data: dataset,
  } = useGetDataset(props.dataset_id);

  return (
    <Can
      perform="dataset:read"
      yes={() => (
        <ReactQueryLoading
          isLoading={isDatasetLoading}
          status={datasetStatus}
          error={datasetError}
          loadingHeight={"40em"}
        >
          {dataset && (
            <>
              <h5>
                {/* <span style={{ color: "#bdbdbd" }}>Dataset:</span>
                {" "} */}
                {dataset.name}
              </h5>
              <CRow>
                <CCol xs="12">
                  {/* <span style={{ color: "#bdbdbd" }}>
                    Dataset Description:
                    </span>{" "} */}
                  {dataset.description}
                </CCol>
              </CRow>
              {!props.just_name_and_description && <>{/* TODO */}</>}
            </>
          )}
        </ReactQueryLoading>
      )}
      no={() => <div>You are not authorized to view this dataset.</div>}
    />
  );
};

DatasetInfo.defaultProps = {
  just_name_and_description: false,
};

DatasetInfo.propTypes = {
  dataset_id: PropTypes.string.isRequired,
  just_name_and_description: PropTypes.bool.isRequired,
};

export default DatasetInfo;
